import { useMutation } from 'react-query';
import { network } from 'services/network';

const extractRowsBoardToCsv = (params) => {
    const url = `api/bo/extractBattleCardToCsv?isCompact=${params.isCompact}`;

    return network.post(url, params.filter).then(() => {
        return true;
    });
};
export const useMutationRowsBoardToCsv = () => {
    return useMutation<unknown, QueryError, IUseMutationRowsBoardToCsvPayload>((params) =>
        extractRowsBoardToCsv(params),
    );
};

interface IUseMutationRowsBoardToCsvPayload {
    fileName: string;
    filter: any;
    isCompact?: boolean;
}